module.exports = __webpack_public_path__ + "img/47.73b9ead4.png";